// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/account.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { OrganizationRole, OrganizationTier } from "./organization_pb";
import { file_gitpod_v1_organization } from "./organization_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/account.proto.
 */
export const file_gitpod_v1_account: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_organization, file_gitpod_v1_pagination, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.GetAccountRequest
 */
export type GetAccountRequest = Message<"gitpod.v1.GetAccountRequest"> & {
};

/**
 * Describes the message gitpod.v1.GetAccountRequest.
 * Use `create(GetAccountRequestSchema)` to create a new message.
 */
export const GetAccountRequestSchema: GenMessage<GetAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 0);

/**
 * @generated from message gitpod.v1.GetAccountResponse
 */
export type GetAccountResponse = Message<"gitpod.v1.GetAccountResponse"> & {
  /**
   * @generated from field: gitpod.v1.Account account = 1;
   */
  account?: Account;
};

/**
 * Describes the message gitpod.v1.GetAccountResponse.
 * Use `create(GetAccountResponseSchema)` to create a new message.
 */
export const GetAccountResponseSchema: GenMessage<GetAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 1);

/**
 * @generated from message gitpod.v1.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"gitpod.v1.DeleteAccountRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * reason is an optional field for the reason for account deletion
   *
   * @generated from field: optional string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message gitpod.v1.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 2);

/**
 * @generated from message gitpod.v1.DeleteAccountResponse
 */
export type DeleteAccountResponse = Message<"gitpod.v1.DeleteAccountResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteAccountResponse.
 * Use `create(DeleteAccountResponseSchema)` to create a new message.
 */
export const DeleteAccountResponseSchema: GenMessage<DeleteAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 3);

/**
 * @generated from message gitpod.v1.Account
 */
export type Account = Message<"gitpod.v1.Account"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated gitpod.v1.AccountMembership memberships = 7;
   */
  memberships: AccountMembership[];

  /**
   * joinables is deprecated. Use ListJoinableOrganizations instead.
   *
   * @generated from field: repeated gitpod.v1.JoinableOrganization joinables = 8 [deprecated = true];
   * @deprecated
   */
  joinables: JoinableOrganization[];

  /**
   * public_email_provider is true if the email for the Account matches a known public email provider
   *
   * @generated from field: bool public_email_provider = 9;
   */
  publicEmailProvider: boolean;

  /**
   * organization_id is the ID of the organization the account is owned by if it's created through custom SSO
   *
   * @generated from field: optional string organization_id = 10;
   */
  organizationId?: string;
};

/**
 * Describes the message gitpod.v1.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema: GenMessage<Account> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 4);

/**
 * @generated from message gitpod.v1.AccountMembership
 */
export type AccountMembership = Message<"gitpod.v1.AccountMembership"> & {
  /**
   * user_id is the ID the user has in the organization
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * user_role is the role the user has in the organization
   *
   * @generated from field: gitpod.v1.OrganizationRole user_role = 2;
   */
  userRole: OrganizationRole;

  /**
   * organization_id is the id of the organization the user is a member of
   *
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * organization_name is the name of the organization the user is a member of
   *
   * @generated from field: string organization_name = 4;
   */
  organizationName: string;

  /**
   * organization_member_count is the member count of the organization the user is a member of
   *
   * @generated from field: int32 organization_member_count = 5;
   */
  organizationMemberCount: number;

  /**
   * organization_tier is the tier of the organization (Free, Core, Enterprise)
   *
   * @generated from field: gitpod.v1.OrganizationTier organization_tier = 6;
   */
  organizationTier: OrganizationTier;
};

/**
 * Describes the message gitpod.v1.AccountMembership.
 * Use `create(AccountMembershipSchema)` to create a new message.
 */
export const AccountMembershipSchema: GenMessage<AccountMembership> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 5);

/**
 * @generated from message gitpod.v1.JoinableOrganization
 */
export type JoinableOrganization = Message<"gitpod.v1.JoinableOrganization"> & {
  /**
   * organization_id is the id of the organization the user can join
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * organization_name is the name of the organization the user can join
   *
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * organization_member_count is the member count of the organization the user can join
   *
   * @generated from field: int32 organization_member_count = 3;
   */
  organizationMemberCount: number;
};

/**
 * Describes the message gitpod.v1.JoinableOrganization.
 * Use `create(JoinableOrganizationSchema)` to create a new message.
 */
export const JoinableOrganizationSchema: GenMessage<JoinableOrganization> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 6);

/**
 * @generated from message gitpod.v1.GetSSOLoginURLRequest
 */
export type GetSSOLoginURLRequest = Message<"gitpod.v1.GetSSOLoginURLRequest"> & {
  /**
   * email is the email the user wants to login with
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * return_to is the URL the user will be redirected to after login
   *
   * @generated from field: optional string return_to = 2;
   */
  returnTo?: string;
};

/**
 * Describes the message gitpod.v1.GetSSOLoginURLRequest.
 * Use `create(GetSSOLoginURLRequestSchema)` to create a new message.
 */
export const GetSSOLoginURLRequestSchema: GenMessage<GetSSOLoginURLRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 7);

/**
 * @generated from message gitpod.v1.GetSSOLoginURLResponse
 */
export type GetSSOLoginURLResponse = Message<"gitpod.v1.GetSSOLoginURLResponse"> & {
  /**
   * login_url is the URL to redirect the user to for SSO login
   *
   * @generated from field: string login_url = 1;
   */
  loginUrl: string;
};

/**
 * Describes the message gitpod.v1.GetSSOLoginURLResponse.
 * Use `create(GetSSOLoginURLResponseSchema)` to create a new message.
 */
export const GetSSOLoginURLResponseSchema: GenMessage<GetSSOLoginURLResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 8);

/**
 * @generated from message gitpod.v1.ListSSOLoginsRequest
 */
export type ListSSOLoginsRequest = Message<"gitpod.v1.ListSSOLoginsRequest"> & {
  /**
   * email is the email the user wants to login with
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * return_to is the URL the user will be redirected to after login
   *
   * @generated from field: optional string return_to = 2;
   */
  returnTo?: string;

  /**
   * pagination contains the pagination options for listing SSO logins
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListSSOLoginsRequest.
 * Use `create(ListSSOLoginsRequestSchema)` to create a new message.
 */
export const ListSSOLoginsRequestSchema: GenMessage<ListSSOLoginsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 9);

/**
 * @generated from message gitpod.v1.ListSSOLoginsResponse
 */
export type ListSSOLoginsResponse = Message<"gitpod.v1.ListSSOLoginsResponse"> & {
  /**
   * @generated from field: repeated gitpod.v1.ListSSOLoginsResponse.Login logins = 1;
   */
  logins: ListSSOLoginsResponse_Login[];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.ListSSOLoginsResponse.
 * Use `create(ListSSOLoginsResponseSchema)` to create a new message.
 */
export const ListSSOLoginsResponseSchema: GenMessage<ListSSOLoginsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 10);

/**
 * @generated from message gitpod.v1.ListSSOLoginsResponse.Login
 */
export type ListSSOLoginsResponse_Login = Message<"gitpod.v1.ListSSOLoginsResponse.Login"> & {
  /**
   * provider is the provider used by this login method, e.g. "github", "google", "custom"
   *
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * login_url is the URL to redirect the user to for SSO login
   *
   * @generated from field: string login_url = 2;
   */
  loginUrl: string;
};

/**
 * Describes the message gitpod.v1.ListSSOLoginsResponse.Login.
 * Use `create(ListSSOLoginsResponse_LoginSchema)` to create a new message.
 */
export const ListSSOLoginsResponse_LoginSchema: GenMessage<ListSSOLoginsResponse_Login> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 10, 0);

/**
 * @generated from message gitpod.v1.ListLoginProvidersRequest
 */
export type ListLoginProvidersRequest = Message<"gitpod.v1.ListLoginProvidersRequest"> & {
  /**
   * pagination contains the pagination options for listing login methods
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains the filter options for listing login methods
   *
   * @generated from field: gitpod.v1.ListLoginProvidersRequest.Filter filter = 2;
   */
  filter?: ListLoginProvidersRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListLoginProvidersRequest.
 * Use `create(ListLoginProvidersRequestSchema)` to create a new message.
 */
export const ListLoginProvidersRequestSchema: GenMessage<ListLoginProvidersRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 11);

/**
 * @generated from message gitpod.v1.ListLoginProvidersRequest.Filter
 */
export type ListLoginProvidersRequest_Filter = Message<"gitpod.v1.ListLoginProvidersRequest.Filter"> & {
  /**
   * invite_id is the ID of the invite URL the user wants to login with
   *
   * @generated from field: optional string invite_id = 1;
   */
  inviteId?: string;

  /**
   * email is the email address to filter SSO providers by
   *
   * @generated from field: optional string email = 2;
   */
  email?: string;
};

/**
 * Describes the message gitpod.v1.ListLoginProvidersRequest.Filter.
 * Use `create(ListLoginProvidersRequest_FilterSchema)` to create a new message.
 */
export const ListLoginProvidersRequest_FilterSchema: GenMessage<ListLoginProvidersRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 11, 0);

/**
 * @generated from message gitpod.v1.ListLoginProvidersResponse
 */
export type ListLoginProvidersResponse = Message<"gitpod.v1.ListLoginProvidersResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.LoginProvider login_providers = 2;
   */
  loginProviders: LoginProvider[];

  /**
   * allow_custom indicates whether custom SSO is allowed for this domain
   *
   * @generated from field: bool allow_custom = 3;
   */
  allowCustom: boolean;
};

/**
 * Describes the message gitpod.v1.ListLoginProvidersResponse.
 * Use `create(ListLoginProvidersResponseSchema)` to create a new message.
 */
export const ListLoginProvidersResponseSchema: GenMessage<ListLoginProvidersResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 12);

/**
 * @generated from message gitpod.v1.LoginProvider
 */
export type LoginProvider = Message<"gitpod.v1.LoginProvider"> & {
  /**
   * login_url is the URL to redirect the browser agent to for login, when provider is "custom"
   *
   * @generated from field: string login_url = 1;
   */
  loginUrl: string;

  /**
   * provider is the provider used by this login method, e.g. "github", "google", "custom"
   *
   * @generated from field: string provider = 2;
   */
  provider: string;
};

/**
 * Describes the message gitpod.v1.LoginProvider.
 * Use `create(LoginProviderSchema)` to create a new message.
 */
export const LoginProviderSchema: GenMessage<LoginProvider> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 13);

/**
 * @generated from message gitpod.v1.ListJoinableOrganizationsRequest
 */
export type ListJoinableOrganizationsRequest = Message<"gitpod.v1.ListJoinableOrganizationsRequest"> & {
  /**
   * pagination contains the pagination options for listing joinable organizations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListJoinableOrganizationsRequest.
 * Use `create(ListJoinableOrganizationsRequestSchema)` to create a new message.
 */
export const ListJoinableOrganizationsRequestSchema: GenMessage<ListJoinableOrganizationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 14);

/**
 * @generated from message gitpod.v1.ListJoinableOrganizationsResponse
 */
export type ListJoinableOrganizationsResponse = Message<"gitpod.v1.ListJoinableOrganizationsResponse"> & {
  /**
   * @generated from field: repeated gitpod.v1.JoinableOrganization joinable_organizations = 1;
   */
  joinableOrganizations: JoinableOrganization[];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.ListJoinableOrganizationsResponse.
 * Use `create(ListJoinableOrganizationsResponseSchema)` to create a new message.
 */
export const ListJoinableOrganizationsResponseSchema: GenMessage<ListJoinableOrganizationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 15);

/**
 * @generated from message gitpod.v1.CreateMagicLinkRequest
 */
export type CreateMagicLinkRequest = Message<"gitpod.v1.CreateMagicLinkRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * Name of the Account
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message gitpod.v1.CreateMagicLinkRequest.
 * Use `create(CreateMagicLinkRequestSchema)` to create a new message.
 */
export const CreateMagicLinkRequestSchema: GenMessage<CreateMagicLinkRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 16);

/**
 * @generated from message gitpod.v1.CreateMagicLinkResponse
 */
export type CreateMagicLinkResponse = Message<"gitpod.v1.CreateMagicLinkResponse"> & {
  /**
   * The magic link to send to the user
   *
   * @generated from field: string magic_link = 1;
   */
  magicLink: string;
};

/**
 * Describes the message gitpod.v1.CreateMagicLinkResponse.
 * Use `create(CreateMagicLinkResponseSchema)` to create a new message.
 */
export const CreateMagicLinkResponseSchema: GenMessage<CreateMagicLinkResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 17);

/**
 * @generated from message gitpod.v1.BlockAccountRequest
 */
export type BlockAccountRequest = Message<"gitpod.v1.BlockAccountRequest"> & {
  /**
   * account_id is the UUID of the account to block
   *
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * reason is the reason for blocking the account (required for audit trail)
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message gitpod.v1.BlockAccountRequest.
 * Use `create(BlockAccountRequestSchema)` to create a new message.
 */
export const BlockAccountRequestSchema: GenMessage<BlockAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 18);

/**
 * @generated from message gitpod.v1.BlockAccountResponse
 */
export type BlockAccountResponse = Message<"gitpod.v1.BlockAccountResponse"> & {
  /**
   * environments_stopped is the number of environments that were stopped
   *
   * @generated from field: int32 environments_stopped = 1;
   */
  environmentsStopped: number;

  /**
   * subscriptions_cancelled is the number of subscriptions that were cancelled
   *
   * @generated from field: int32 subscriptions_cancelled = 2;
   */
  subscriptionsCancelled: number;
};

/**
 * Describes the message gitpod.v1.BlockAccountResponse.
 * Use `create(BlockAccountResponseSchema)` to create a new message.
 */
export const BlockAccountResponseSchema: GenMessage<BlockAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 19);

/**
 * @generated from message gitpod.v1.UnblockAccountRequest
 */
export type UnblockAccountRequest = Message<"gitpod.v1.UnblockAccountRequest"> & {
  /**
   * account_id is the UUID of the account to unblock
   *
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message gitpod.v1.UnblockAccountRequest.
 * Use `create(UnblockAccountRequestSchema)` to create a new message.
 */
export const UnblockAccountRequestSchema: GenMessage<UnblockAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 20);

/**
 * @generated from message gitpod.v1.UnblockAccountResponse
 */
export type UnblockAccountResponse = Message<"gitpod.v1.UnblockAccountResponse"> & {
};

/**
 * Describes the message gitpod.v1.UnblockAccountResponse.
 * Use `create(UnblockAccountResponseSchema)` to create a new message.
 */
export const UnblockAccountResponseSchema: GenMessage<UnblockAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 21);

/**
 * @generated from message gitpod.v1.GetChatIdentityTokenRequest
 */
export type GetChatIdentityTokenRequest = Message<"gitpod.v1.GetChatIdentityTokenRequest"> & {
};

/**
 * Describes the message gitpod.v1.GetChatIdentityTokenRequest.
 * Use `create(GetChatIdentityTokenRequestSchema)` to create a new message.
 */
export const GetChatIdentityTokenRequestSchema: GenMessage<GetChatIdentityTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 22);

/**
 * @generated from message gitpod.v1.GetChatIdentityTokenResponse
 */
export type GetChatIdentityTokenResponse = Message<"gitpod.v1.GetChatIdentityTokenResponse"> & {
  /**
   * email_hash is the HMAC-SHA256 hash of the account's email address,
   * used for chat widget identity verification
   *
   * @generated from field: string email_hash = 1;
   */
  emailHash: string;
};

/**
 * Describes the message gitpod.v1.GetChatIdentityTokenResponse.
 * Use `create(GetChatIdentityTokenResponseSchema)` to create a new message.
 */
export const GetChatIdentityTokenResponseSchema: GenMessage<GetChatIdentityTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_account, 23);

/**
 * @generated from service gitpod.v1.AccountService
 */
export const AccountService: GenService<{
  /**
   * Gets information about the currently authenticated account.
   *
   * Use this method to:
   * - Retrieve account profile information
   * - Check organization memberships
   * - View account settings
   * - Get joinable organizations
   *
   * ### Examples
   *
   * - Get account details:
   *
   *   Retrieves information about the authenticated account.
   *
   *   ```yaml
   *   {}
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.GetAccount
   */
  getAccount: {
    methodKind: "unary";
    input: typeof GetAccountRequestSchema;
    output: typeof GetAccountResponseSchema;
  },
  /**
   * Deletes an account permanently.
   *
   * Use this method to:
   * - Remove unused accounts
   * - Clean up test accounts
   * - Complete account deletion requests
   *
   * The account must not be an active member of any organization.
   *
   * ### Examples
   *
   * - Delete account:
   *
   *   Permanently removes an account.
   *
   *   ```yaml
   *   accountId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof DeleteAccountResponseSchema;
  },
  /**
   * Gets the SSO login URL for a specific email domain.
   *
   * Use this method to:
   * - Initiate SSO authentication
   * - Get organization-specific login URLs
   * - Handle SSO redirects
   *
   * ### Examples
   *
   * - Get login URL:
   *
   *   Retrieves SSO URL for email domain.
   *
   *   ```yaml
   *   email: "user@company.com"
   *   ```
   *
   * - Get URL with return path:
   *
   *   Gets SSO URL with specific return location.
   *
   *   ```yaml
   *   email: "user@company.com"
   *   returnTo: "https://gitpod.io/workspaces"
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.GetSSOLoginURL
   */
  getSSOLoginURL: {
    methodKind: "unary";
    input: typeof GetSSOLoginURLRequestSchema;
    output: typeof GetSSOLoginURLResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.AccountService.ListSSOLogins
   */
  listSSOLogins: {
    methodKind: "unary";
    input: typeof ListSSOLoginsRequestSchema;
    output: typeof ListSSOLoginsResponseSchema;
  },
  /**
   * Lists available login providers with optional filtering.
   *
   * Use this method to:
   * - View supported authentication methods
   * - Get provider-specific login URLs
   * - Filter providers by invite
   *
   * ### Examples
   *
   * - List all providers:
   *
   *   Shows all available login providers.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - List for specific invite:
   *
   *   Shows providers available for an invite.
   *
   *   ```yaml
   *   filter:
   *     inviteId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.ListLoginProviders
   */
  listLoginProviders: {
    methodKind: "unary";
    input: typeof ListLoginProvidersRequestSchema;
    output: typeof ListLoginProvidersResponseSchema;
  },
  /**
   * Lists organizations that the currently authenticated account can join.
   *
   * Use this method to:
   * - Discover organizations associated with the account's email domain.
   * - Allow users to join existing organizations.
   * - Display potential organizations during onboarding.
   *
   * ### Examples
   *
   * - List joinable organizations:
   *
   *   Retrieves a list of organizations the account can join.
   *
   *   ```yaml
   *   {}
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.ListJoinableOrganizations
   */
  listJoinableOrganizations: {
    methodKind: "unary";
    input: typeof ListJoinableOrganizationsRequestSchema;
    output: typeof ListJoinableOrganizationsResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.AccountService.CreateMagicLink
   */
  createMagicLink: {
    methodKind: "unary";
    input: typeof CreateMagicLinkRequestSchema;
    output: typeof CreateMagicLinkResponseSchema;
  },
  /**
   * Blocks an account, preventing all API access.
   *
   * Use this method to:
   * - Revoke access for policy violations
   * - Handle abuse cases
   * - Enforce compliance requirements
   *
   * When an account is blocked:
   * - All API requests return 403 PERMISSION_DENIED
   * - All running environments are stopped
   * - All active subscriptions are cancelled
   *
   * Requires the `block_account` permission.
   *
   * ### Examples
   *
   * - Block account for policy violation:
   *
   *   ```yaml
   *   accountId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   reason: "Terms of Service violation - spam"
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.BlockAccount
   */
  blockAccount: {
    methodKind: "unary";
    input: typeof BlockAccountRequestSchema;
    output: typeof BlockAccountResponseSchema;
  },
  /**
   * Unblocks a previously blocked account, restoring API access.
   *
   * Use this method to:
   * - Restore access after resolving policy violations
   * - Reinstate accounts after review
   *
   * Note: Unblocking does NOT restore:
   * - Stopped environments (must be restarted manually)
   * - Cancelled subscriptions (must be re-subscribed)
   * - Deleted resources
   *
   * Requires the `block_account` permission.
   *
   * ### Examples
   *
   * - Unblock account:
   *
   *   ```yaml
   *   accountId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.UnblockAccount
   */
  unblockAccount: {
    methodKind: "unary";
    input: typeof UnblockAccountRequestSchema;
    output: typeof UnblockAccountResponseSchema;
  },
  /**
   * Gets the chat identity token for the currently authenticated account.
   *
   * Use this method to:
   * - Obtain a verification hash for in-app chat identity verification
   * - Secure chat sessions against impersonation
   *
   * The returned hash is an HMAC-SHA256 signature of the account's email,
   * used by the chat widget to verify user identity.
   *
   * ### Examples
   *
   * - Get chat identity token:
   *
   *   Retrieves the identity verification hash for the authenticated account.
   *
   *   ```yaml
   *   {}
   *   ```
   *
   * @generated from rpc gitpod.v1.AccountService.GetChatIdentityToken
   */
  getChatIdentityToken: {
    methodKind: "unary";
    input: typeof GetChatIdentityTokenRequestSchema;
    output: typeof GetChatIdentityTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_account, 0);

